module.exports = __webpack_public_path__ + "static/media/sputnik.1442c495.png";